import React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import Divider from "../../lib/divider";
import MarkersTable from "../audio_management/markers_table";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { getMarkersByShowUUID } from "../../../action_managers/markers";
import map from "lodash/map";
import get from "lodash/get";
import { AlbumArt } from "../../lib/album-art";
import { ShowFetchActionManager } from "../../../action_managers/shows";
import { useComponentDidMount } from "../../../lib/hook";

const ShowMarkersPage = props => {
  const markerByUUID = useSelector(state => state.markers.markers);
  const user = useSelector(state => state.user.user);
  const markers = map(markerByUUID, marker => marker);
  const dispatch = useDispatch();
  const showUUID = props.match.params.showUUID;
  const showImageURL = useSelector(state => get(state.shows.shows, [showUUID, "imageURL"]));

  useComponentDidMount(() => {
    dispatch(getMarkersByShowUUID(showUUID));
    if (!showImageURL) {
      dispatch(new ShowFetchActionManager({ auth: true, showUUID, user }).run());
    }
  }, []);

  return (
    <div className="page-wrapper">
      <Grid fluid>
        <Row>
          <Col xs={4} md={4} lg={4}>
            <AlbumArt className="show-markers-page__album-art" src={showImageURL} />
          </Col>
          <Col xs={8} md={8} lg={8}>
            <Row>
              <Col className="page-header-margin--top">
                <div className="flex-row-container align-end">
                  <h1 className="no-margin no-padding">Markers</h1>
                  <div className="flex-1" />
                  <button className="btn-link bold no-padding">Add New Markers</button>
                </div>
                <Divider smallMargin />
              </Col>
            </Row>
            <Row>
              <Col>
                <MarkersTable markers={markers} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default withRouter(ShowMarkersPage);
